import { render, staticRenderFns } from "./SessionIcon.vue?vue&type=template&id=3963f57a&scoped=true&"
import script from "./SessionIcon.vue?vue&type=script&lang=js&"
export * from "./SessionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963f57a",
  null
  
)

export default component.exports